import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { ORDER_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/orderConstants';
import {
  ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
  ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const OrderCancelList = (props) => {
  const { orderCancelList, mainProductCategorySelectList, getList, getExcelDownload } = props;
  const { list, filterOption, sortOption, pagination, summary } = orderCancelList;

  return (
    <div className="order-all-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: ORDER_CANCEL_LIST_FILTER_OPTION_MODEL,
          sortOption: ORDER_CANCEL_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        getExcelDownload={getExcelDownload}
        isStriped={true}
        emptyText={ORDER_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        columns={(utils) =>
          columns({
            ...utils,
            mainProductCategorySelectList,
          })
        }
      />
    </div>
  );
};

export default OrderCancelList;
